import { XML_AddSingle } from "./XML_AddSingle.js";
import { XML_ShiftRect } from "./XML_ShiftRect.js";
import { XML_Param3 } from "./XML_Param3.js";
import { GetFieldLabel } from "./GetFieldLabel";
import { XML_Param5 } from "./XML_Param5.js";
import { enumFieldDisplayMode } from "../constants";

export function XML_DrawCellChartPPT(
  cell,
  r,
  data,
  doLegend,
  fontSize,
  txtFillStyle,
  drawElement,
  theLayer
) {
  cell.GetCellDesc().BuildPieChartContent();
  var s = drawElement.GetStream();
  XML_ShiftRect(r, drawElement, theLayer);
  r.fTop = drawElement.ConvertY(r.fTop);
  r.fBottom = drawElement.ConvertY(r.fBottom);

  var theHeight = Math.abs(r.fTop - r.fBottom);
  var theWidth = Math.abs(r.fRight - r.fLeft);

  var width = cell.GetWidth();
  var radius = width / 2.5 - 4;
  var ratio = radius / width;
  var diameter = 2 * ((r.fRight - r.fLeft) * ratio) - 4;

  var displayMode = cell.GetCellDesc().GetFieldDisplayMode();
  var doLabel = displayMode !== enumFieldDisplayMode.FieldOnly;
  var myField = cell.GetField();
  var fontColor = txtFillStyle;

  var dataStr = JSON.stringify(data);
  drawElement.OutputElementHead(s, "chrt");
  XML_AddSingle("pie", "type", drawElement);
  XML_Param3("legend", doLegend, fontSize, fontColor, drawElement);
  if (myField && doLabel) {
    var label = GetFieldLabel(myField);
    XML_AddSingle(label, "label", drawElement);
  }
  XML_Param5("pos", r.fLeft, r.fBottom, theWidth, theHeight, diameter, drawElement);
  XML_AddSingle(dataStr, "data", drawElement);
  drawElement.OutputElementTail(s, "chrt");
}
